<template>
  <div class="login__form">
    <h2 class="login__title">Logowanie</h2>
    <form @submit.prevent="submitPassword">
      <div class="form-group">
        <label class="label" for="username">E-mail</label>
        <div class="input--icon-wrap input--icon-user">
          <input
            v-model="username"
            type="email"
            class="input"
            :class="{ 'input--error': authError }"
            name="username"
            autocomplete="username"
            placeholder="nazwa@domena.com"
          />
        </div>
      </div>
      <div class="form-group">
        <input-password
          id="password"
          v-model="password"
          autocomplete="current-password"
          :errors="authError"
          :prevent-paste="false"
        >
          Hasło
        </input-password>
      </div>
      <div v-if="authError" class="form-error">{{ authError }}</div>
      <div class="login__remember-forget-info">
        <div class="login__remember-me">
          <label for="remember" class="label-checkbox label-checkbox--small">
            <input
              id="remember"
              v-model="remember"
              type="checkbox"
              name="remember"
            />
            <span>Zapamiętaj mnie</span>
          </label>
        </div>
        <router-link
          :to="{ name: 'forgotPassword' }"
          class="text-button--underline"
        >
          Zapomniałeś hasła?
        </router-link>
      </div>
      <action-button :loading="loading" type="submit" class="login__button">
        Zaloguj się
      </action-button>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { loginAPIPoint } from "@/apiEndpoints";
import { clearAuthToken, storeAuthToken } from "@/utils/authToken";

import InputPassword from "@/views/components/formFields/InputPassword.vue";

import { obtainFetchError } from "@/utils/errors";

export default {
  name: "TheLoginForm",
  components: { InputPassword },
  data() {
    return {
      username: "",
      password: "",
      confirmPassword: "",
      remember: false,
      authError: "",
      loading: false,
    };
  },
  methods: {
    ...mapActions(["initialize"]),
    ...mapActions("mfa", ["getMfaError"]),
    async submitPassword() {
      this.authError = "";
      clearAuthToken();

      if (!this.username || !this.password) {
        this.authError = "Uzupełnij nazwę użytkownika i hasło.";
        return;
      }

      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);

      this.loading = true;
      try {
        const authResponse = await fetch(loginAPIPoint, {
          method: "POST",
          body: formData,
        });
        const authResponseData = await authResponse.json();
        if (authResponseData["token"] && authResponse.status === 200) {
          // success
          storeAuthToken(authResponseData["token"], this.remember);
          await this.initialize();
          this.username = "";

          this.$emit("success");
        } else if (authResponseData["non_field_errors"]) {
          this.authError = authResponseData["non_field_errors"][0]?.message;
        } else {
          this.authError = "Nieoczekiwana odpowiedź serwera. Spróbuj ponownie.";
        }
      } catch (error) {
        console.error(error);
        const { errors } = obtainFetchError(error);
        this.authError =
          errors?.code === "request_challenge_not_allowed"
            ? "Przekroczono limit prób logowania. Spróbuj ponownie później."
            : "Wystąpił problem połączenia z serwerem. Spróbuj ponownie.";
      } finally {
        this.loading = false;
        this.password = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/_breakpoints.scss";

.login__button {
  margin: 32px auto 0;
  width: 100%;
  display: block;
}

.text-button--underline {
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
}

.login__remember-forget-info {
  display: flex;
  justify-content: space-between;
  font-size: $label-font-size;
  margin-top: 27px;
  align-items: center;
}

.label-checkbox--small {
  font-size: $label-font-size;
}

.label-checkbox {
  align-items: center;
}

@include breakpoint-mobile-narrow-up {
  .login__button {
    max-width: 280px;
  }
}
</style>
